import { useAuthStore } from './AuthStoreProvider';

export function useAuthState() {
   const { isAuthenticated, user, accessToken } = useAuthStore(state => state);

   return {
      isAuthenticated,
      user,
      accessToken,
   };
}

export function useAuthDispatches() {
   const { logout, login, updateProfile } = useAuthStore(state => state);

   return {
      logout,
      login,
      updateProfile,
   };
}
